<template id="deliveryForm">
  <div>

    <div class="container" style="margin-bottom: 10px;">
      <b-card no-body class="text-center" style="font-size: 15px; padding: 1em;">
        <i>Εισάγετε το PIN και τα 4 τελευταία ψηφία της ταυτότητας του φοιτητή/σπουδαστή και πατήστε "Εμφάνιση βιβλίων" για να εμφανιστούν τα βιβλία προς παράδοση</i>
      </b-card>
    </div>

    <b-container>
      <b-collapse visible id="dpForm">
        <form @submit="submitForm">
          <label><b>Κωδικός PIN</b></label>
          <b-form-input v-model="pin"
                        type="text"
                        required
                        :state="pinState"
                        maxlength="12"
                        placeholder="Πληκτρολογήστε εδώ..."></b-form-input>
          <b-form-text>Εισάγετε τον αριθμό PIN του φοιτητή</b-form-text>
          <br/>
          <label><b>Ταυτότητα Παραλήπτη</b></label>
          <b-form-input v-model="receiverIdentification"
                 type="text"
                 required
                 maxlength="4"
                 :state="receiverIdentificationState"
                 placeholder="Πληκτρολογήστε εδώ..."></b-form-input>
          <b-form-text>Εισάγετε τα τελευταία 4 ψηφία του αριθμού αστυνομικής ή ακαδημαϊκής ταυτότητας του φοιτητή
          </b-form-text>
          <br/>
          <b-button id="booksButton"
                    type="submit"
                    variant="outline-info">Εμφάνιση Βιβλίων
          </b-button>
        </form>
      </b-collapse>
      <b-alert :show="creditsFlag"
               dismissible
               @dismissed="creditsFlag=false"
               variant="warning">
        {{creditsMessage}}
      </b-alert>
    </b-container>
  </div>
</template>

<script>

  import requests from '../../js/DistributionRequestService';
  import {GlobalEudoxusBus} from '../../js/DistributionRequestService';
  import BookListComponent from './BookListComponent.vue';

  export default {
    template: '#deliveryForm',
    computed: {
      pinLength () {
        return this.pin.length > 11;
      },
      receiverLength () {
        return this.receiverIdentification.length > 3;
      }
    },
    data: function () {
      return {
        pin: '',
        creditsMessage: "",
        creditsFlag: false,
        receiverIdentification: '',
        pinState: null,
        receiverIdentificationState: null,
        componentTag: 'deliveryFormComponent'
      }
    },
    methods: {
      submitForm: function () {
        this.creditsMessageAlert(false, "");
        if (this.validateCredits()) {
          requests.getBooksForDelivery(this.pin, this.receiverIdentification, null);
          this.$emit('toggleView', 'bookListComponent');
        }
      },
      validateCredits() {
        if (this.pin.length !== 12 || isNaN(this.pin)) {
          this.pinState = false;
          this.creditsMessageAlert(true, "Ο κωδικός PIN πρέπει να ειναι 12 αριθμητικά ψηφία!");
          return false;
        }
        if (this.receiverIdentification.length !== 4) {
          this.receiverIdentificationState = false;
          this.creditsMessageAlert(true, "Η ταυτότητα παραλήπτη πρέπει να είναι 4 χαρακτήρες!");
          return false;
        }
        return true;
      },
      creditsMessageAlert(flag, msg) {
        this.creditsMessage = msg;
        this.creditsFlag = flag;
      },
      setUpComponent() {
        this.$emit('toggleView', this.componentTag);
        this.creditsMessageAlert(false, "");
      }
    },
    created() {
      GlobalEudoxusBus.$on('globalSetupEvent', globalSetupEvent => {
        if (globalSetupEvent)
          this.setUpComponent();
      });
    }
  }
</script>

<style scoped>

  #booksButton {
    margin-bottom: 1em;
  }

</style>



// WEBPACK FOOTER //
// src/components/BookDeliveryTabComponents/DeliveryFormComponent.vue